/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable dot-location */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode, useEffect, useState } from "react";
import infoIcon from "../../../assets/images/i.png";
import {
  Col,
  Container,
  Row,
  Form,
  CardBody,
  Card,
  Label,
  Input,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavLink,
  NavItem,
  CardHeader,
  Collapse,
  UncontrolledTooltip,
  Media,
  FormFeedback,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import check from "../../../assets/images/nick.png";
import Nic from "../../../assets/images/nic.png";
import fbr from "../../../assets/images/fbr.png";
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import {
  FirebaseAuthBackend,
  getFirebaseBackend,
} from "helpers/firebase_helper";
import Loader from "Components/Common/Loader";
import {
  getBank,
  updateBankInformation,
  updateBussinessInformation,
} from "live-slices/thunk";
import { createSelector } from "reselect";
import AddressFormBox from "Components/Common/AddressFormBox";
import { useNavigate } from "react-router-dom";
import withRouter from "Components/Common/withRouter";
import { toast } from "react-toastify";
import { updateUserState } from "live-slices/user/reducer";
import ImageViewer from "Components/Common/ImageViewer";
import ImageForNic from "../../../assets/images/image.png";
import Check from "../../../assets/images/check.png";
import "../../../assets/scss/pages/_onBoarding.scss";
import BuypassAddressSelector, {
  AddressModel,
  BuypassAdressValidationSchema,
} from "Components/Common/BuypassAddressSelector";
import { getOptionToSetTouched } from "utils/helperfunctions";
import FieldComplete from "../../../assets/images/fieldComplete.png";
import FieldInComplete from "../../../assets/images/fieldCross.png";
import CnicBack from "../../../assets/images/cnicback.png";
import CnicFront from "../../../assets/images/cnicfront.png";
import Cheque from "../../../assets/images/cheque.jpg";
import MediaUploader from "Components/Common/MediaUploader";
import ErrorModal from "Components/Common/ErrorModal";

// Register the plugins

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  defaultOpen: boolean;
}

interface CnicUploadCardProps {
  imageValue: string | null;
  handleImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleDeleteImage: () => void;
  openViewer: (image: string) => void;
  closeViewer: () => void;
  isViewerOpen: boolean;
  currentImage: string;
  imageId: string;
}

const CollapsibleSection: React.FC<{
  title: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  titleNew: React.ReactNode;
  isComplete: boolean;
  onToggle: () => void;
}> = ({ title, children, isOpen, onToggle, titleNew, isComplete }) => {
  return (
    <div
      className={`card-container ${isOpen ? "open" : ""} mt-2 shadow-lg`}
      style={{ cursor: "pointer", borderRadius: "10px" }}
    >
      <div
        className="d-flex justify-content-between align-items-center p-3 pointer-event"
        onClick={onToggle}
        style={{
          backgroundColor: isOpen
            ? "#FFFFFF"
            : isComplete
            ? "#ECF5FF"
            : "#FFECEC",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <div className="d-flex align-items-center w-100 justify-content-between">
          <div className="d-flex align-items-center">
            <i
              className={`ri-arrow-${isOpen ? "up" : "down"}-s-line fs-20`}
              style={{ marginRight: "10px", color: "#0877FF" }}
            />
            <h5 className="card-title-ob mb-0 mobileResboxUnCom">{title}</h5>
          </div>
          <div>{titleNew}</div>
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <CardBody>{children}</CardBody>
      </Collapse>
    </div>
  );
};

const CnicUploadCard: React.FC<CnicUploadCardProps> = ({
  imageValue,
  handleImageChange,
  handleDeleteImage,
  openViewer,
  closeViewer,
  isViewerOpen,
  currentImage,
  imageId,
}) => (
  <Card className="mb-3 dottedborder">
    {/* <div className="label-container">
            {label} <span>*</span>
        </div> */}

    {!imageValue && (
      <>
        <Label
          htmlFor={imageId}
          className="upload-label"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          title="Select Image"
        >
          <img src={ImageForNic} alt="Upload" />
          <div className="upload-text mt-2">Upload or Drop file here.</div>
          <div className="upload-text max-size">Max file size: 10 MB</div>
        </Label>
        <Input
          className="form-control d-none"
          id={imageId}
          type="file"
          accept="image/png, image/gif, image/jpeg"
          onChange={handleImageChange}
          data-testion-id="nicUploadInput_BankInformTwo"
        />
      </>
    )}

    {imageValue && (
      <div className="p-2">
        <Row className="align-items-center">
          <Col>
            <div className="image-container">
              <img
                src={imageValue}
                alt="Selected document"
                onClick={() => openViewer(imageValue)}
              />
              <i
                className="bx bx-trash delete-icon"
                onClick={handleDeleteImage}
              ></i>
            </div>
            <ImageViewer
              isOpen={isViewerOpen}
              imageUrl={currentImage}
              toggle={closeViewer}
            />
          </Col>
        </Row>
      </div>
    )}
  </Card>
);

interface ChildFormProps {
  setFormikRef: (instance: { handleSubmit: () => Promise<boolean> }) => void;
}

const BankIdInformation: React.FC<ChildFormProps> = ({ setFormikRef }) => {
  document.title = "Bank Information | BuyPass";
  const [sellerType, setSellerType] = useState("personal");
  const [faqsType, setfaqsType] = useState("faqsOne");
  const [address, setaddress] = useState<any>();
  const [accountType, setAccountType] = useState("");
  const [activeVerticalTab, setactiveVerticalTab] = useState<number>(7);
  const [passedverticalSteps, setPassedverticalSteps] = useState<any>([1]);
  const [selectFrontCnicImageLoading, setSelectFrontCnicImageLoading] =
    useState<any>(false);
  const [selectBackCnicImageLoading, setSelectBackCnicImageLoading] =
    useState<any>(false);
  const [selectImageBankLoading, setSelectImageBankLoading] =
    useState<any>(false);
  const [selectImageBusinessLoading, setSelectImageBusinessLoading] =
    useState<any>(false);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [hasLoadedDraft, setHasLoadedDraft] = useState(false);
  const [draftData, setDraftData] = useState<any>();

  const [openIndex, setOpenIndex] = useState<number | null>(0); // Default to first section being open

  const handleToggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const firebaesHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [selectedFrontCnicImage, setSelectedFrontCnicImage] = useState<any>();
  const [selectedBackCnicImage, setSelectedBackCnicImage] = useState<any>();
  const [selectedBusinessImage, setSelectedBusinessImage] = useState<any>();
  const [selectedImageBank, setSelectedImageBank] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const closeViewer = () => {
    setViewerOpen(false);
  };
  const validationSchemaBusiness = Yup.object({
    companyLegalName: Yup.string().required("Company Legal Name is required"),
    businessRegistrationNumber: Yup.string().required(
      "Business Registration Number is required"
    ),
    address: Yup.object(BuypassAdressValidationSchema),
  });

  const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
  const accountNumberRegex = /^[0-9]{11,16}$/;
  const validationSchema = Yup.object({
    // companyLegalName: Yup.string()
    //   .required('Name on ID is required'),
    // businessRegistrationNumber: Yup.string()
    //   .required('ID Number is required'),

    accountName: Yup.string().required("Account Name is required"),
    accountNumber: Yup.string()
      .required("Account Number is required")
      .matches(accountNumberRegex, "Allows 16 digits"),
    Iban: Yup.string()
      .required("This field is required")
      .test("conditional-validation", "Invalid input", function (value) {
        const { bank } = this.parent;

        if (!value) return false;

        const cleanedValue = value.replace(/\s|-/g, "");
        const phonePattern = /^(\+92|92|0)?3[0-9]{9}$/;
        const ibanPattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

        const phoneOnlyBanks = ["easypaisa", "sadapay", "nayapay", "jazzcash"];

        if (
          bank &&
          phoneOnlyBanks.some((b) => bank.toLowerCase().includes(b))
        ) {
          return (
            phonePattern.test(cleanedValue) ||
            this.createError({
              message: "Enter valid phone number Start With 0 or +92",
            })
          );
        } else {
          return (
            ibanPattern.test(cleanedValue) ||
            this.createError({
              message:
                "Should be Alpha numeric, 24 digits field, start with PK",
            })
          );
        }
      }),

    bankBranch: Yup.string().required("Bank Branch is required"),
    // bankCode: Yup.string()
    //     .required('Bank Code is required'),
    cnicName: Yup.string().required("Cnic name is required"),
    businessRegistrationNumber: Yup.string().test(
      "businessRegistrationNumber-required",
      "Business Registration Number is required",
      function (value) {
        if (seller?.accountType === "business" && !value) {
          return this.createError({
            message: "Business Registration Number is required",
          });
        }
        return true;
      }
    ),

    selectedBusinessImage: Yup.string().test(
      "selectedBusinessImage-required",
      "Trademark certificate is required",
      function (value) {
        if (seller?.accountType === "business" && !value) {
          return this.createError({
            message: "Trademark certificate is required",
          });
        }
        return true;
      }
    ),
    cnicNumber: Yup.string()
      .max(15, "Cnic Number cannot be more than 13 characters")
      .required("Cnic number is required"),
    address: Yup.string().when("isBusinessAddressSame", {
      is: (isBusinessAddressSame: boolean) => isBusinessAddressSame === false,
      otherwise: (schema: any) => Yup.object().notRequired(),
      then: (schema: any) => Yup.object(BuypassAdressValidationSchema),
    }),
    cnicFrontImage: Yup.string().required("Cnic Front Image is required"),
    cnicBackImage: Yup.string().required("Cnic Back Image is required"),
    bankDocuments: Yup.string().required("Bank Document Image is required"),
  });

  const formik = useFormik({
    initialValues: {
      accountName: "",
      accountNumber: "",
      Iban: "",
      bank: "",
      bankCode: "",
      bankBranch: "",
      companyLegalName: "",
      businessRegistrationNumber: "",
      selectedBusinessImage: "",
      sellerType: "",
      businessDocuments: "",
      cnicNumber: "",
      bankDocuments: "",
      accountType: "",
      cnicFrontImage: "",
      cnicBackImage: "",
      cnicName: "",
      streetAddress: "",
      state: "",
      city: "",
      zone: "",
      isBusinessAddressSame: true,
      neighborhood: "",
      address: new AddressModel(),
    },
    validationSchema:
      sellerType === "business" ? validationSchemaBusiness : validationSchema,

    onSubmit: async (values) => {
      // if (sellerType === "business") {
      //     if (!values.businessDocuments) {
      //         toast.error("Business Documents Image is required");
      //         return;
      //     }
      // } else {
      //     if (!values.cnicFrontImage) {
      //         toast.error("Cnic Front Image is required");
      //         return;
      //     }
      //     if (!values.cnicBackImage) {
      //         toast.error("Cnic Back Image is required");
      //         return;
      //     }
      //     if (!values.bankDocuments) {
      //         toast.error("Bank Documents Image is required");
      //         return;
      //     }
      // }
    },
  });

  const openViewer = (imageUrl: any) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const handleSellerTypeChange = (e: any) => {
    const value = e.target.value;
    setSellerType(value);

    // Update accountType based on sellerType
    if (value === "personal") {
      setAccountType("personalAccountType");
    } else {
      setAccountType("businessAccountType");
    }
  };

  const handleFaqsTypeChange = (e: any) => {
    const value = e.target.value;
    setfaqsType(value);

    // Update accountType based on sellerType
    if (value === "personal") {
      setAccountType("personalAccountType");
    } else {
      setAccountType("businessAccountType");
    }
  };

  const handleFrontCnicImageChange = async (event: any) => {
    setSelectFrontCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedFrontCnicImage(fileObj);
        formik.setFieldValue("cnicFrontImage", fileObj.url);
      }
      setSelectedFrontCnicImage(false);
    } catch (e) {
      setSelectFrontCnicImageLoading(false);
      console.log(e);
    }
  };

  const handleBackCnicImageChange = async (event: any) => {
    setSelectBackCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedBackCnicImage(fileObj);
        formik.setFieldValue("cnicBackImage", fileObj.url);
      }
      setSelectBackCnicImageLoading(false);
    } catch (e) {
      setSelectBackCnicImageLoading(false);
      console.log(e);
    }
  };

  const handleBussinessImageChange = async (event: any) => {
    setSelectImageBusinessLoading(true);
    try {
      const file = event.target.files[0];
      const res = await firebaesHelper?.uploadImage(file, "product/");
      const fileObj = getFileObj(file, res);
      setSelectedBusinessImage(fileObj);
      formik.setFieldValue("businessDocuments", fileObj.url);
      setSelectedImageBank(getFileObj(file, res));
      setSelectImageBusinessLoading(false);
    } catch (e) {
      setSelectImageBusinessLoading(false);
      console.log(e);
    }
  };

  const handleBankImageChange = async (event: any) => {
    setSelectImageBankLoading(true);
    try {
      const file = event.target.files[0];
      const res = await firebaesHelper?.uploadImage(file, "product/");
      const fileObj = getFileObj(file, res);
      setSelectedImageBank(fileObj);
      formik.setFieldValue("bankDocuments", fileObj.url);

      setSelectedImageBank(getFileObj(file, res));
      setSelectImageBankLoading(false);
    } catch (e) {
      setSelectImageBankLoading(false);
      console.log(e);
    }
  };

  const handleDeleteFrontCnicImage = () => {
    formik.setFieldValue("cnicFrontImage", "");
    formik.setFieldValue("cnicFrontImageMetadata", {});
    setSelectedFrontCnicImage(null);
  };

  const handleDeleteBackCnicImage = () => {
    formik.setFieldValue("cnicBackImage", "");
    formik.setFieldValue("cnicBackImageMetadata", {});
    setSelectedBackCnicImage(null);
  };

  const handleDeleteBusinessImage = () => {
    formik.setFieldValue("businessDocuments", "");
    formik.setFieldValue("businessDocumentsMetadata", {});
    setSelectedBusinessImage(null);
  };

  const handleDeleteImageBank = () => {
    formik.setFieldValue("bankDocuments", "");
    formik.setFieldValue("bankDocumentsMetadata", {});
    setSelectedImageBank(null);
  };

  const dispatch = useDispatch<any>();

  function toggleVerticalTab(tab: any) {
    if (activeVerticalTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];

      if (tab >= 7 && tab <= 11) {
        setactiveVerticalTab(tab);
        setPassedverticalSteps(modifiedSteps);
      }
    }
  }

  const selectSeller = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );

  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user
  );

  const user = useSelector(selectUser);
  const seller = useSelector(selectSeller);
  console.log(seller, "seller");

  const [banks, setBanks] = useState([]);
  const fetchBankDetails = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getBank()).unwrap();
      setBanks(response);
    } catch (error) {
      console.error("Error fetching banks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, [dispatch]);

  useEffect(() => {
    if (!seller || hasLoadedDraft) return;
    formik.setFieldValue("accountType", seller?.accountType || "");
    formik.setFieldValue(
      "accountName",
      seller?.idBankDetails?.accountName || ""
    );
    formik.setFieldValue(
      "accountNumber",
      seller?.idBankDetails?.accountNumber || ""
    );
    formik.setFieldValue("Iban", seller?.idBankDetails?.Iban || "");
    formik.setFieldValue("bank", seller?.idBankDetails?.bank || "");
    formik.setFieldValue("bankCode", seller?.idBankDetails?.bankCode || "");
    formik.setFieldValue("bankBranch", seller?.idBankDetails?.bankBranch || "");
    formik.setFieldValue(
      "isBusinessAddressSame",
      seller?.idBankDetails?.isBusinessAddressSame ?? true
    );
    if (
      seller &&
      seller.idBankDetails &&
      Array.isArray(seller.idBankDetails.bankDocuments)
    ) {
      formik.setFieldValue(
        "bankDocuments",
        seller.idBankDetails.bankDocuments[0]?.url || ""
      );
      setSelectedImageBank(seller.idBankDetails.bankDocuments[0].url);
    } else {
      formik.setFieldValue("bankDocuments", "");
      setSelectedImageBank("");
    }
    if (
      seller &&
      seller.idBankDetails &&
      Array.isArray(seller.idBankDetails.businessDocuments)
    ) {
      formik.setFieldValue(
        "businessDocuments",
        seller.idBankDetails.businessDocuments[0]?.url || ""
      );
    } else {
      formik.setFieldValue("businessDocuments", "");
    }
    formik.setFieldValue("cnicNumber", seller?.nationality?.cnicNumber || "");
    formik.setFieldValue(
      "businessRegistrationNumber",
      seller?.idBankDetails?.businessRegistrationNumber || ""
    );
    formik.setFieldValue("sellerType", seller?.accountType || "");
    formik.setFieldValue("companyLegalName", seller?.address?.state || "");
    formik.setFieldValue(
      "cnicBackImage",
      seller?.nationality?.cnicBackImage.url || ""
    );
    if (seller.nationality && seller.nationality.cnicFrontImage?.url) {
      formik.setFieldValue(
        "cnicFrontImage",
        seller.nationality.cnicFrontImage.url
      );
      setSelectedFrontCnicImage(seller.nationality.cnicFrontImage.url);
    } else {
      formik.setFieldValue("cnicFrontImage", "");
      setSelectedFrontCnicImage("");
    }
    // formik.setFieldValue("cnicFrontImage", seller?.nationality?.cnicNumber || "");
    formik.setFieldValue("cnicName", seller?.nationality?.cnicName || "");

    if (seller?.idBankDetails?.businessAddress) {
      formik.setFieldValue("address", {
        ...formik.values.address,
        ...AddressModel.copyFromObject(seller.idBankDetails.businessAddress),
      });
    }
  }, [seller, hasLoadedDraft]);

  // useEffect(() => {
  //     if (seller?.idBankDetails?.businessAddress) {
  //         const updatedValues = {
  //             ...formik.values,
  //             address: {
  //                 ...formik.values.address,
  //                 ...AddressModel.copyFromObject(seller.idBankDetails.businessAddress),
  //             },
  //         };
  //         formik.setValues(updatedValues, false);
  //     }
  // }, [seller]);

  const handleToggle = () => {
    formik.setFieldValue(
      "isBusinessAddressSame",
      !formik.values.isBusinessAddressSame
    );
    console.log("data", formik.values.isBusinessAddressSame);
  };

  React.useEffect(() => {
    setFormikRef({
      handleSubmit: async () => {
        const errors = await formik.validateForm();
        let errorMessages: string[] = [];
        let isValidate = false;
        if (sellerType === "business" && !formik.values.businessDocuments) {
          errorMessages.push("Business Documents Image is required");
        } else {
          // if (!formik.values.cnicFrontImage) {
          //     errorMessages.push("Cnic Front Image is required");
          // }
          // if (!formik.values.cnicBackImage) {
          //     errorMessages.push("Cnic Back Image is required");
          // }
          // if (!formik.values.bankDocuments) {
          //     errorMessages.push("Bank Documents Image is required");
          // }
        }

        const length = formik.values.accountNumber?.length || 0;

        if (!formik.values.accountNumber || length < 11 || length > 16) {
          errorMessages.push("Account Number must be between 11 and 16 digits");
        }

        const cleanedIban = (formik.values.Iban || "").replace(/\s|-/g, "");
        const phonePattern = /^(\+92|92|0)?3[0-9]{9}$/;
        const ibanPattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
        const phoneOnlyBanks = ["easypaisa", "sadapay", "nayapay", "jazzcash"];

        if (!formik.values.Iban) {
          errorMessages.push("IBAN is required");
        } else {
          if (
            formik.values.bank &&
            phoneOnlyBanks.some((b) =>
              formik.values.bank.toLowerCase().includes(b)
            )
          ) {
            if (!phonePattern.test(cleanedIban)) {
              errorMessages.push(
                "Enter valid phone number Start With 0 or +92 for mobile wallet banks"
              );
            }
          } else {
            if (!ibanPattern.test(cleanedIban)) {
              errorMessages.push(
                "IBAN should be alpha-numeric and properly formatted"
              );
            }
          }
        }

        if (Object.keys(errors).length === 0 && errorMessages.length === 0) {
          const updatedSeller: any = {
            _id: seller._id,
            idBankDetails: {
              businessAddress: AddressModel.copyFromObject(
                formik.values.address
              ),

              swift: seller.swift || "Abc",
              isBusinessAddressSame: formik.values.isBusinessAddressSame,

              businessDocuments: [
                {
                  url: formik.values.selectedBusinessImage!,
                  metaData: {
                    height: 0,
                    width: 0,
                    fileType: "",
                    fileFormat: "",
                    name: "",
                    duration: 0,
                  },
                },
              ],
              companyLegalName: formik.values.companyLegalName || "",
              businessRegistrationNumber:
                formik.values.businessRegistrationNumber || "",
              bankDocuments: [
                {
                  url: formik.values.bankDocuments || "",
                  metaData: {
                    height: 0,
                    width: 0,
                    fileType: "",
                    fileFormat: "",
                    name: "",
                    duration: 0,
                  },
                },
              ],
              accountName: formik.values.accountName || "",
              accountNumber: formik.values.accountNumber || "",
              Iban: formik.values.Iban || "",
              bank: formik.values.bank || "",
              bankCode: formik.values.bankCode || "",
              bankBranch: formik.values.bankBranch || "",
            },
            nationality: {
              cnicFrontImage: {
                url: formik.values.cnicFrontImage || "",
                metaData: {
                  height: 0,
                  width: 0,
                  fileType: "",
                  fileFormat: "",
                  name: "",
                  duration: 0,
                },
              },
              cnicBackImage: {
                url: formik.values.cnicBackImage || "",
                metaData: {
                  height: 0,
                  width: 0,
                  fileType: "",
                  fileFormat: "",
                  name: "",
                  duration: 0,
                },
              },
              cnicNumber: formik.values.cnicNumber || "",
              cnicName: formik.values.cnicName || "",
            },
          };
          let response = await dispatch(
            updateBankInformation({ formData: updatedSeller, navigate })
          );
          if (response && response.payload === "Failed to update business") {
            // toast.error("Failed to update business", { autoClose: 1000 });
            setShowModal(true);
            setErrorMessage("Failed to update business");
            setTimeout(() => {
              setShowModal(false);
            }, 2000);
            isValidate = false;
          } else {
            isValidate = true;

            // toast.success("Business Information Added Successfully", { autoClose: 1000 });
            setShowModal(true);
            setErrorMessage("Business Information Added Successfully");
            setTimeout(() => {
              setShowModal(false);
            }, 2000);
            await dispatch(
              updateUserState({
                storeStatus: {
                  ...user.storeStatus,
                  isIdBankDetails: true,
                },
              })
            );
          }
        } else {
          if (errorMessages.length) {
            try {
              // console.log("count===>1")
              let variableCheck = (
                <div>
                  {errorMessages.map((msg, index) => (
                    <div key={index}>{msg}</div>
                  ))}
                </div>
              );

              // toast.error(
              //     variableCheck,{autoClose:1000}
              // );
            } catch (e) {
              console.log(e);
            }
          }
          const objectToSetTouched = getOptionToSetTouched(formik.values);
          formik.setTouched(objectToSetTouched);
        }
        return isValidate;
      },
    });
  }, [formik, setFormikRef, sellerType]);
  const navigate = useNavigate();

  const phoneOnlyBanks = ["easypaisa", "sadapay", "nayapay", "jazzcash"];

  const isPhoneBasedBank = phoneOnlyBanks.some((b: any) =>
    formik.values.bank?.toLowerCase().includes(b)
  );

  const ibanPlaceholder = isPhoneBasedBank
    ? "Phone Number (e.g. 03XXXXXXXXX or +923XXXXXXXXX)"
    : "IBAN (ex:AA00AAAA000000000000000)";

  const handleFieldChange = (key: string, e: any) => {
    formik.setFieldValue(key, e.target.value);
  };

  const getFileObj = (file: any, url: any) => {
    return {
      url,
      metadata: {
        height: file.height || 0,
        width: file.width || 0,
        fileType: file.type || "string",
        fileFormat: file.name.split(".").pop() || "string",
        name: file.name || "string",
        duration: file.duration || 0,
      },
    };
  };

  const onBusinessAddressChange = (address: any) => {
    setaddress(address);
  };

  const onMediaUpdate = (key: string, value: Media | any) => {
    console.log(key, value);
    let url: string | undefined;
    let media: Media | undefined;

    if (Array.isArray(value)) {
      url = value[0]?.url;
      media = value[0];
    } else {
      url = value?.url;
      media = value;
    }

    if (key === "selectedImageBank") {
      setSelectedImageBank(value);
      if (url) {
        formik.setFieldValue("bankDocuments", url);
      } else {
        formik.setFieldValue("bankDocuments", "");
      }
    } else if (key === "selectedFrontCnicImage") {
      setSelectedFrontCnicImage(value);
      if (url) {
        formik.setFieldValue("cnicFrontImage", url);
      } else {
        formik.setFieldValue("cnicFrontImage", "");
      }
    } else if (key === "selectedBackCnicImage") {
      setSelectedBackCnicImage(value);
      if (url) {
        formik.setFieldValue("cnicBackImage", url);
      } else {
        formik.setFieldValue("cnicBackImage", "");
      }
    } else if (key === "selectedBusinessImage") {
      setSelectedBusinessImage(value);
      if (url) {
        formik.setFieldValue("selectedBusinessImage", url);
      } else {
        formik.setFieldValue("selectedBusinessImage", "");
      }
    }
  };

  useEffect(() => {
    const requiredFields = [
      "cnicFrontImage",
      "cnicBackImage",
      "cnicName",
      "cnicNumber",
      "bankDocuments",
      "accountName",
      "bank",
      "accountNumber",
      "Iban",
      "bankBranch",
    ];

    const hasData = requiredFields.some(
      (key) =>
        formik.values[key as keyof typeof formik.values] &&
        formik.values[key as keyof typeof formik.values]?.toString().trim() !==
          ""
    );

    if (hasData) {
      const filteredData = Object.fromEntries(
        requiredFields.map((key) => [
          key,
          formik.values[key as keyof typeof formik.values],
        ])
      );
      localStorage.setItem("step3", JSON.stringify(filteredData));
    }
  }, [formik.values]);

  useEffect(() => {
    const savedData = localStorage.getItem("step3");
    if (savedData) {
      const parsedData = JSON.parse(savedData);

      const relevantFields = [
        "cnicFrontImage",
        "cnicBackImage",
        "cnicName",
        "cnicNumber",
        "bankDocuments",
        "accountName",
        "bank",
        "accountNumber",
        "Iban",
        "bankBranch",
      ];

      const isAnyFieldFilled = relevantFields.some(
        (field) =>
          parsedData[field] !== undefined &&
          parsedData[field] !== null &&
          parsedData[field] !== ""
      );

      if (isAnyFieldFilled) {
        setShowDraftModal(true);
      }
    }
  }, []);

  const onLocalDraftContinue = () => {
    const savedData = localStorage.getItem("step3");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      console.log(parsedData, "localdata");

      if (parsedData?.cnicBackImage) {
        const backImageWithMeta = {
          url: parsedData.cnicBackImage,
          metaData: {
            height: 0,
            width: 0,
            fileType: "image/jpeg",
            fileFormat: "jpeg",
            name: "cnic-back.jpeg",
            duration: 0,
          },
        };

        formik.setFieldValue("cnicBackImage", parsedData.cnicBackImage); // Backend ke liye string
        setSelectedBackCnicImage(backImageWithMeta); // MediaUploader ke liye object
      } else {
        formik.setFieldValue("cnicBackImage", "");
        setSelectedBackCnicImage("");
      }

      if (parsedData.cnicFrontImage) {
        const frontImageWithMeta = {
          url: parsedData.cnicFrontImage,
          metaData: {
            height: 0,
            width: 0,
            fileType: "image/jpeg",
            fileFormat: "jpeg",
            name: "cnic-front.jpeg",
            duration: 0,
          },
        };

        formik.setFieldValue("cnicFrontImage", parsedData.cnicFrontImage); // Yeh string hi rakhna agar backend mein string expected ho
        setSelectedFrontCnicImage(frontImageWithMeta); // Yeh object hoga MediaUploader ke liye
      } else {
        formik.setFieldValue("cnicFrontImage", "");
        setSelectedFrontCnicImage("");
      }

      if (parsedData.bankDocuments) {
        const frontImageWithMeta = {
          url: parsedData.bankDocuments,
          metaData: {
            height: 0,
            width: 0,
            fileType: "image/jpeg",
            fileFormat: "jpeg",
            name: "cnic-front.jpeg",
            duration: 0,
          },
        };

        formik.setFieldValue("bankDocuments", parsedData.bankDocuments); // Yeh string hi rakhna agar backend mein string expected ho
        setSelectedImageBank(frontImageWithMeta); // Yeh object hoga MediaUploader ke liye
      } else {
        formik.setFieldValue("bankDocuments", "");
        setSelectedImageBank("");
      }

      formik.setValues({
        ...formik.values,
        ...parsedData,
      });

      setShowDraftModal(false);
    }
  };

  const handleDiscard = () => {
    localStorage.removeItem("step3");
    setShowDraftModal(false);
  };

  return (
    <>
      <Modal isOpen={showDraftModal}>
        <ModalBody>
          <p>
            You have unsaved data. Would you like to continue with your previous
            entries or start fresh?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onLocalDraftContinue}>
            Continue
          </Button>
          <Button color="danger" onClick={handleDiscard}>
            Discard
          </Button>
        </ModalFooter>
      </Modal>

      <div className="bankForm">
        <Form onSubmit={formik.handleSubmit}>
          <div data-testing-id="uploadNIC_BankformTwo">
            <CollapsibleSection
              title="Upload NIC"
              titleNew={
                <div>
                  {formik.values.cnicFrontImage &&
                  formik.values.cnicBackImage ? (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Complete
                      </span>
                      <img
                        src={FieldComplete}
                        alt="Complete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Incomplete
                      </span>
                      <img
                        src={FieldInComplete}
                        alt="Incomplete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  )}
                </div>
              }
              isComplete={
                !!(formik.values.cnicFrontImage && formik.values.cnicBackImage)
              }
              isOpen={openIndex === 0}
              onToggle={() => handleToggleIndex(0)}
            >
              <h3 className="fw-bold mb-2 shop-title">
                Upload NIC (National ID){" "}
              </h3>
              <p className="shop-details-description">
                To verify your identity, upload clear images of the front and
                back of your NIC
              </p>
              <Row className="rounded-3 py-3 px-0">
                <Col sm={6} xs={6} md={4} lg={4} xxl={4}>
                  <MediaUploader
                    onMediaUpdate={(value: any) =>
                      onMediaUpdate("selectedFrontCnicImage", value)
                    }
                    isMultiple={false}
                    initialMedia={
                      selectedFrontCnicImage ||
                      seller?.nationality?.cnicFrontImage
                    }
                    title="Front"
                    isRequired={true}
                    dataTestingId="selectedFrontCnicImage"
                  />

                  {formik.touched.cnicFrontImage && (
                    <FormFeedback type="invalid" className="d-block">
                      {" "}
                      {formik.errors.cnicFrontImage}{" "}
                    </FormFeedback>
                  )}

                  <div className="d-flex flex-column align-items-start mb-4">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={Check}
                        alt="Check Icon"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "8px",
                        }}
                      />
                      <span style={{ color: "#A2B1C3", fontSize: "12px" }}>
                        Min size: 480x480 px. Max file size: 10MB.
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <img
                        src={Check}
                        alt="Check Icon"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "8px",
                        }}
                      />
                      <span style={{ color: "#A2B1C3", fontSize: "12px" }}>
                        Supported Format: JPG.
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={6} xs={6} md={4} lg={4} xxl={4}>
                  <MediaUploader
                    onMediaUpdate={(value: any) =>
                      onMediaUpdate("selectedBackCnicImage", value)
                    }
                    isMultiple={false}
                    initialMedia={
                      selectedBackCnicImage ||
                      seller?.nationality?.cnicBackImage ||
                      draftData?.cnicBackImage
                    }
                    title="Back"
                    isRequired={true}
                    dataTestingId="selectedBackCnicImage"
                  />
                  {formik.touched.cnicBackImage && (
                    <FormFeedback type="invalid" className="d-block">
                      {" "}
                      {formik.errors.cnicBackImage}{" "}
                    </FormFeedback>
                  )}

                  <div className="d-flex flex-column align-items-start mb-3">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={Check}
                        alt="Check Icon"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "8px",
                        }}
                      />
                      <span className="Supported">
                        Min size: 480x480 px. Max file size: 10MB.
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <img src={Check} alt="Check Icon" className="imgDvvv" />
                      <span className="Supported">Supported Format: JPG.</span>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={4} lg={4} xxl={4}>
                  <Card
                    className=""
                    style={{
                      border: "2px solid #00FF99",
                      borderRadius: "8px",
                      backgroundColor: "#F0FFF9",
                      padding: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "black",
                        fontWeight: "600",
                        marginBottom: "15px",
                      }}
                    >
                      Quick Guide
                    </h5>
                    <p
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      <strong>Step 1:</strong> Place it on a flat surface with
                      good lighting
                    </p>
                    <p
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      <strong>Step 2:</strong> Take clear pictures of both sides
                      of your ID (front & back).
                    </p>
                    <div className="row">
                      <div className="col-6 text-start">
                        <div
                          style={{
                            textDecoration: "underline",
                            marginTop: "5px",
                            color: "#0877FF",
                            fontStyle: "italic",
                            marginBottom: "5px",
                          }}
                        >
                          Example Front Side
                        </div>
                        <img
                          src={CnicFront}
                          alt="Front side"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                      <div className="col-6 text-start">
                        <div
                          style={{
                            textDecoration: "underline",
                            marginTop: "5px",
                            color: "#0877FF",
                            fontStyle: "italic",
                            marginBottom: "5px",
                          }}
                        >
                          Example Back Side
                        </div>
                        <img
                          src={CnicBack}
                          alt="Back side"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </CollapsibleSection>
          </div>

          <div data-testing-id="verifyIdInformation_BankformTwo">
            <CollapsibleSection
              title="Verify ID Information"
              titleNew={
                <div>
                  {formik.values.cnicName && formik.values.cnicNumber ? (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Complete
                      </span>
                      <img
                        src={FieldComplete}
                        alt="Complete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Incomplete
                      </span>
                      <img
                        src={FieldInComplete}
                        alt="Incomplete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  )}
                </div>
              }
              isComplete={
                !!(formik.values.cnicName && formik.values.cnicNumber)
              }
              isOpen={openIndex === 1}
              onToggle={() => handleToggleIndex(1)}
            >
              <h3 className="fw-bold my-2 shop-title">Verify ID Information</h3>
              <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                <div className="formContainer">
                  <Label htmlFor="cnicName" className="form-label">
                    <span className="text-danger me-1"> *</span>Name on ID
                    (Needs to be exactly the same)
                  </Label>
                  <Input
                    type="text"
                    name="cnicName"
                    className={`form-control ${
                      formik.touched.cnicName && formik.errors.cnicName
                        ? "is-invalid"
                        : ""
                    }`}
                    id="cnicName"
                    placeholder="Input exactly the same as photo uploaded"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("cnicName", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.cnicName}
                    data-testing-id="nameOnCnicInput_BankInformTwo"
                  />
                  {formik.touched.cnicName && formik.errors.cnicName && (
                    <div className="invalid-feedback">
                      {formik.errors.cnicName}
                    </div>
                  )}
                </div>
              </Col>
              <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                <div className="formContainer">
                  <Label htmlFor="cnicNumber" className="form-label">
                    <span className="text-danger me-1"> *</span>Identity Card
                    No.
                  </Label>
                  <Input
                    type="text"
                    name="cnicNumber"
                    className={`form-control ${
                      formik.touched.cnicNumber &&
                      (formik.errors.cnicNumber ||
                        formik.values.cnicNumber.length > 15)
                        ? "is-invalid"
                        : ""
                    }`}
                    id="cnicNumber"
                    placeholder="The official number on ID"
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      if (value.length > 13) value = value.slice(0, 13);
                      if (value.length > 5)
                        value = `${value.slice(0, 5)}-${value.slice(5)}`;
                      if (value.length > 13)
                        value = `${value.slice(0, 13)}-${value.slice(13)}`;
                      formik.setFieldValue("cnicNumber", value);
                      handleFieldChange("cnicNumber", { target: { value } });
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.cnicNumber}
                    data-testing-id="cnicCardNumberInput_BankInformTwo"
                  />
                  {formik.touched.cnicNumber && formik.errors.cnicNumber && (
                    <div className="invalid-feedback">
                      {formik.errors.cnicNumber}
                    </div>
                  )}
                  {formik.touched.cnicNumber &&
                    formik.values.cnicNumber.length > 15 && (
                      <div className="invalid-feedback">
                        Only 13 characters are allowed.
                      </div>
                    )}
                </div>
              </Col>
            </CollapsibleSection>
          </div>

          {seller?.accountType === "business" && (
            <div data-testing-id="verifyIdInformation_BankformTwo">
              <CollapsibleSection
                title="Business Verification Document"
                titleNew={
                  <div>
                    {formik.values.businessRegistrationNumber &&
                    formik.values.selectedBusinessImage ? (
                      <div>
                        <span
                          className="ms-2"
                          style={{
                            fontStyle: "italic",
                            fontSize: "14px",
                            color: "black",
                            fontWeight: 400,
                          }}
                        >
                          Complete
                        </span>
                        <img
                          src={FieldComplete}
                          alt="Complete"
                          height={24}
                          width={24}
                          style={{ marginLeft: "10px" }}
                        />
                      </div>
                    ) : (
                      <div>
                        <span
                          className="ms-2"
                          style={{
                            fontStyle: "italic",
                            fontSize: "14px",
                            color: "black",
                            fontWeight: 400,
                          }}
                        >
                          Incomplete
                        </span>
                        <img
                          src={FieldInComplete}
                          alt="Incomplete"
                          height={24}
                          width={24}
                          style={{ marginLeft: "10px" }}
                        />
                      </div>
                    )}
                  </div>
                }
                isComplete={
                  !!(
                    formik.values.businessRegistrationNumber &&
                    formik.values.selectedBusinessImage
                  )
                }
                isOpen={openIndex === 6}
                onToggle={() => handleToggleIndex(6)}
              >
                <h3 className="fw-bold my-2 shop-title">
                  Verify Business Document
                </h3>
                <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                  <div className="formContainer">
                    <Label
                      htmlFor="businessRegistrationNumber"
                      className="form-label"
                    >
                      <span className="text-danger me-1"> *</span>Enter your
                      Business NTN
                    </Label>
                    <Input
                      type="number"
                      name="businessRegistrationNumber"
                      className={`form-control ${
                        formik.touched.businessRegistrationNumber &&
                        formik.errors.businessRegistrationNumber
                          ? "is-invalid"
                          : ""
                      }`}
                      id="businessRegistrationNumber"
                      placeholder="Enter your Business NTN"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("businessRegistrationNumber", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.businessRegistrationNumber}
                      data-testing-id="nameOnCnicInput_BankInformTwo"
                    />
                    {formik.touched.businessRegistrationNumber &&
                      formik.errors.businessRegistrationNumber && (
                        <div className="invalid-feedback">
                          {formik.errors.businessRegistrationNumber}
                        </div>
                      )}
                  </div>
                </Col>
                <Col sm={12} md={4} lg={4} xxl={4}>
                  <MediaUploader
                    onMediaUpdate={(value: any) =>
                      onMediaUpdate("selectedBusinessImage", value)
                    }
                    isMultiple={false}
                    initialMedia={
                      selectedBusinessImage ||
                      seller?.idBankDetails?.businessDocuments
                    }
                    title="Trademark certificate"
                    isRequired={true}
                  />
                  {formik.touched.selectedBusinessImage && (
                    <FormFeedback type="invalid" className="d-block">
                      {" "}
                      {formik.errors.selectedBusinessImage}{" "}
                    </FormFeedback>
                  )}

                  <div className="d-flex flex-column align-items-start mb-3">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={Check}
                        alt="Check Icon"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "8px",
                        }}
                      />
                      <span className="Supported">
                        Min size: 480x480 px. Max file size: 10MB.
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <img src={Check} alt="Check Icon" className="imgDvvv" />
                      <span className="Supported">Supported Format: JPG.</span>
                    </div>
                  </div>
                </Col>
              </CollapsibleSection>
            </div>
          )}

          <div data-testing-id="uploadBankDocument_BankformTwo">
            <CollapsibleSection
              title="Upload Bank Document"
              titleNew={
                <>
                  {formik.values.bankDocuments ? (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Complete
                      </span>
                      <img
                        src={FieldComplete}
                        alt="Complete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Incomplete
                      </span>
                      <img
                        src={FieldInComplete}
                        alt="Incomplete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  )}
                </>
              }
              isComplete={!!formik.values.bankDocuments}
              isOpen={openIndex === 3}
              onToggle={() => handleToggleIndex(3)}
            >
              {/* <p>Here is the description for uploading your bank document. Ensure it's clear and includes account details.</p> */}
              <h3 className=" fw-bolder mb-2 shop-title">
                Upload Bank Document
              </h3>
              {/* <h6 className="text-black-50">Size between 330x330 and 5000x5000 px, and image size below 10m.Please do upload the photo with the example</h6> */}
              <Row className="rounded-3 flex-row justify-content-between mt-3">
                <Col sm={12} md={4} lg={4} xxl={4}>
                  {/* <h6 className="fw-bold "> <span className="text-danger me-1">*</span>Cheque Book<img src={infoIcon} alt="" height={14} width={14} style={{marginLeft:"10px"}} /></h6> */}

                  {/* <CnicUploadCard
                                imageValue={formik.values.bankDocuments}
                                handleImageChange={handleBankImageChange}
                                handleDeleteImage={handleDeleteImageBank}
                                openViewer={openViewer}
                                closeViewer={closeViewer}
                                isViewerOpen={isViewerOpen}
                                currentImage={currentImage}
                                imageId="customer-image-bank-input"
                            /> */}
                  <MediaUploader
                    onMediaUpdate={(value: any) =>
                      onMediaUpdate("selectedImageBank", value)
                    } // Handle image update
                    isMultiple={false}
                    initialMedia={
                      selectedImageBank || seller?.idBankDetails?.bankDocuments
                    }
                    title="Cheque Book"
                    isRequired={true}
                    dataTestingId="chequeBook"
                  />
                  {formik.touched.bankDocuments && (
                    <FormFeedback type="invalid" className="d-block">
                      {" "}
                      {formik.errors.bankDocuments}{" "}
                    </FormFeedback>
                  )}

                  <div className="d-flex flex-column align-items-start mb-3">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={Check}
                        alt="Check Icon"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "8px",
                        }}
                      />
                      <span className="Supported">
                        Min size: 480x480 px. Max file size: 10MB.
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <img src={Check} alt="Check Icon" className="imgDvvv" />
                      <span className="Supported">Supported Format: JPG.</span>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={4} lg={4} xxl={4}>
                  <Card className="bank-document-card">
                    <ul>
                      <li>
                        Please upload any of the below-mentioned bank documents
                        with a clear bank account name, bank account number, and
                        bank name with no object covering this information
                        (submit a screenshot with account title, account number
                        & IBAN in case of EWallet). Please make sure your bank
                        account name is the same as your ID name (company name
                        in case of corporate sellers):
                        <br />
                        **A. For Bank**
                        <br />
                        1. Screenshot of a cheque
                        <br />
                        2. Screenshot of mobile/internet banking
                        <br />
                        3. Screenshot of bank statement (Top part only)
                        <br />
                        4. Account maintenance Certification letter from the
                        bank
                        <br />
                        <br />
                        **B. For e-Wallets**
                        <br />
                        1. Screenshot of the "Account profile": My account View
                        profile/account Information
                      </li>
                    </ul>
                    <div className="col-6 text-start">
                      <div
                        style={{
                          textDecoration: "underline",
                          marginTop: "5px",
                          color: "#0877FF",
                          fontStyle: "italic",
                          marginBottom: "5px",
                        }}
                      >
                        Example
                      </div>
                      <img
                        src={Cheque}
                        alt="Front side"
                        style={{ width: "100%", height: "auto" }}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
            </CollapsibleSection>
          </div>

          <div data-testing-id="verifyBankInformation_BankformTwo">
            <CollapsibleSection
              title="Verify Bank Information"
              titleNew={
                <>
                  {formik.values.accountName &&
                  formik.values.accountNumber &&
                  formik.values.Iban &&
                  formik.values.bank &&
                  formik.values.bankBranch ? (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Complete
                      </span>
                      <img
                        src={FieldComplete}
                        alt="Complete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Incomplete
                      </span>
                      <img
                        src={FieldInComplete}
                        alt="Incomplete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  )}
                </>
              }
              isComplete={
                !!(
                  formik.values.accountName &&
                  formik.values.accountNumber &&
                  formik.values.Iban &&
                  formik.values.bank &&
                  formik.values.bankBranch
                )
              }
              isOpen={openIndex === 4}
              onToggle={() => handleToggleIndex(4)}
            >
              {/* <p>Here you can verify your bank details. Please ensure the details are accurate and match your documents.</p> */}
              <div className="form">
                <h3 className=" fw-bold mb-3 shop-title  ">
                  Verify Bank Information
                </h3>
                <Col xxl={4} md={4} sm={4} lg={4}>
                  <div className="formContainer">
                    <Label htmlFor="addressDetails" className="form-label">
                      <span className="text-danger me-1"> *</span>Account Name
                    </Label>
                    <Input
                      type="text"
                      name="addressDetails"
                      className={`form-control ${
                        formik.touched.accountName && formik.errors.accountName
                          ? "is-invalid"
                          : ""
                      }`}
                      id="accountName"
                      placeholder="First And last Name"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("accountName", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.accountName}
                      data-testing-id="accountNameInput_BankInformTwo"
                    />
                    {formik.touched.accountName &&
                      formik.errors.accountName && (
                        <div className="invalid-feedback">
                          {formik.errors.accountName}
                        </div>
                      )}
                  </div>
                </Col>

                <Col xxl={4} md={4} sm={4} lg={4}>
                  <div className="formContainer mt-3">
                    <Label htmlFor="bank" className="form-label">
                      <span className="text-danger me-1"> *</span>Bank
                    </Label>
                    <select
                      className={`form-select mb-3 ${
                        formik.touched.bank && formik.errors.bank
                          ? "is-invalid"
                          : ""
                      }`}
                      name="bank"
                      onChange={(e) => {
                        formik.handleChange(e);
                        formik.setFieldValue("Iban", "");
                        formik.setFieldValue("accountNumber", "");
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.bank}
                      data-testing-id="bankSelect_BankInformTwo"
                    >
                      <option value="">Select Bank</option>
                      {loading && <option>Loading...</option>}
                      {!loading &&
                        banks.map((bank: any, index: any) => (
                          <option
                            key={bank._id}
                            value={bank.value || bank.id}
                            data-testing-id={
                              "selectBankOption_BankInformTwo" + index
                            }
                          >
                            {bank.label || bank.name}
                          </option>
                        ))}
                    </select>
                    {formik.touched.bank && formik.errors.bank && (
                      <div className="invalid-feedback">
                        {formik.errors.bank}
                      </div>
                    )}
                  </div>
                </Col>
                <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                  <div className="formContainer">
                    <Label htmlFor="addressDetails" className="form-label">
                      <span className="text-danger me-1"> *</span>Account Number
                    </Label>
                    <Input
                      type="text"
                      name="accountNumber"
                      className={`form-control ${
                        formik.touched.accountNumber &&
                        formik.errors.accountNumber
                          ? "is-invalid"
                          : ""
                      }`}
                      id="accountNumber"
                      placeholder="Bank Account Number"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        const fakeEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            value: value,
                          },
                        };
                        formik.handleChange(fakeEvent);
                        handleFieldChange("accountNumber", fakeEvent);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.accountNumber}
                      data-testing-id="accountNumberInput_BankInformTwo"
                    />
                    {formik.touched.accountNumber &&
                      formik.errors.accountNumber && (
                        <div className="invalid-feedback">
                          {formik.errors.accountNumber}
                        </div>
                      )}
                  </div>
                </Col>
                <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                  <div className="formContainer">
                    <Label htmlFor="Iban" className="form-label">
                      <span className="text-danger me-1"> *</span>IBAN
                    </Label>
                    <Input
                      type="text"
                      name="Iban"
                      className={`form-control ${
                        formik.touched.Iban && formik.errors.Iban
                          ? "is-invalid"
                          : ""
                      }`}
                      id="Iban"
                      // placeholder="IBAN (ex:AA00AAAA000000000000000)"
                      placeholder={ibanPlaceholder}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("Iban", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.Iban}
                      data-testing-id="IBANInput_BankInformTwo"
                    />
                    {formik.touched.Iban && formik.errors.Iban && (
                      <div className="invalid-feedback">
                        {formik.errors.Iban}
                      </div>
                    )}
                  </div>
                </Col>

                {/* <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                                <div className="formContainer">
                                    <Label htmlFor="bankCode" className="form-label">
                                        <span className="text-danger me-1"> *</span>Bank Code
                                    </Label>
                                    <Input
                                        type="text"
                                        name="bankCode"
                                        className={`form-control ${formik.touched.bankCode && formik.errors.bankCode
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        id="bankCode"
                                        placeholder="Bank Code"
                                        onChange={(e) => {
                                            if (e.target.value.length <= 4) {
                                                formik.handleChange(e);
                                                handleFieldChange("bankCode", e);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bankCode}
                                        data-testing-id="bankCodeInput_BankInformTwo"
                                        maxLength={4}
                                    />
                                    {formik.touched.bankCode && formik.errors.bankCode && (
                                        <div className="invalid-feedback">
                                            {formik.errors.bankCode}
                                        </div>
                                    )}
                                </div>

                            </Col> */}
                <Col xxl={4} md={4} sm={4} lg={4} className="mt-3">
                  <div className="formContainer">
                    <Label htmlFor="bankBranch" className="form-label">
                      <span className="text-danger me-1"> *</span>Bank Branch
                    </Label>
                    <Input
                      type="text"
                      name="bankBranch"
                      className={`form-control ${
                        formik.touched.bankBranch && formik.errors.bankBranch
                          ? "is-invalid"
                          : ""
                      }`}
                      id="bankBranch"
                      placeholder="Bank Branch"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("bankBranch", e);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.bankBranch}
                      data-testing-id="bankBranchInput_BankInformTwo"
                    />
                    {formik.touched.bankBranch && formik.errors.bankBranch && (
                      <div className="invalid-feedback">
                        {formik.errors.bankBranch}
                      </div>
                    )}
                  </div>
                </Col>
              </div>
            </CollapsibleSection>
          </div>

          <ErrorModal
            show={showModal}
            message={errorMessage}
            onCloseClick={() => setShowModal(false)}
          />

          <div data-testing-id="businessAdress_BankformTwo " className="mb-3">
            <CollapsibleSection
              title="Business Address"
              titleNew={
                <>
                  {formik.values.isBusinessAddressSame ||
                  (formik.values.address.city &&
                    formik.values.address.neighborhood &&
                    // formik.values.address.type &&
                    formik.values.address.streetAddress &&
                    formik.values.address.plazaMarketName &&
                    formik.values.address.shopName &&
                    formik.values.address.shopNumber &&
                    formik.values.address.zone &&
                    formik.values.address.state) ? (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Complete
                      </span>
                      <img
                        src={FieldComplete}
                        alt="Complete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <span
                        className="ms-2"
                        style={{
                          fontStyle: "italic",
                          fontSize: "14px",
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Incomplete
                      </span>
                      <img
                        src={FieldInComplete}
                        alt="Incomplete"
                        height={24}
                        width={24}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  )}
                </>
              }
              isComplete={Boolean(
                formik.values.isBusinessAddressSame ||
                  (formik.values.address.city &&
                    formik.values.address.neighborhood &&
                    formik.values.address.streetAddress &&
                    formik.values.address.plazaMarketName &&
                    formik.values.address.shopName &&
                    formik.values.address.shopNumber &&
                    formik.values.address.zone &&
                    formik.values.address.state)
              )}
              isOpen={openIndex === 5}
              onToggle={() => handleToggleIndex(5)}
            >
              <h5 className="fw-bolder mb-3 shop-title">Business Address</h5>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={formik.values.isBusinessAddressSame}
                  onChange={handleToggle}
                />
                <p>Same as Shop Address</p>
              </div>
              {!formik.values.isBusinessAddressSame && (
                <Col xxl={4} md={4} sm={4} lg={4}>
                  <BuypassAddressSelector formik={formik} />
                </Col>
              )}
            </CollapsibleSection>
          </div>
        </Form>
      </div>
    </>
  );
};

export default withRouter(BankIdInformation);
